<template>
    <div>
        <div class="vx-card p-6">
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     :components="components"
                     :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="activeData"
                     :animateRows="true"
                     :pagination="true"
                     :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                     :paginationPageSize="paginationPageSize"
                     :onGridReady="onGridReady"
                     :suppressPaginationPanel="true">
        </ag-grid-vue>
        </div>
    </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

export default {
    components:{
        AgGridVue
    },
    data(){
        return {
            activeData:[
                { stt:'Nguyễn Việt Anh',
                  time:'098999969',
                  from:'surface studio 2Plus platium',
                  to:'vô thời hạn'
                },
            ],
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Tên nhân viên',
                    field: 'stt',
                    width: 300
                },
                {
                    headerName: 'Số nội bộ',
                    field: 'time',
                    width: 300,
                },
                {
                    headerName: 'Tên thiết bị',
                    field: 'from',
                    width: 300
                },
                {
                    headerName: 'Hết hạn',
                    field: 'to',
                    width: 300
                },
            ],
        }
    }
}
</script>